import React from "react";
import { useCartUiActions, useCartDrawerIsOpen } from "./cartStore";
import { CartDrawer } from "./CartDrawer";
import { OverviewPage } from "./CartDrawer/pages/OverviewPage";
import { storefrontApi } from "@/services/storefront";
import { DroppsCatalog, DroppsProduct, droppsCatalog } from "@/store";

const Cart = () => {
  const { closeDrawer } = useCartUiActions();
  const isOpen = useCartDrawerIsOpen();
  const allProducts: DroppsCatalog | undefined =
    storefrontApi.useAllProducts().data;

  return (
    <CartDrawer
      open={isOpen}
      onExit={closeDrawer}
      goToFirstPage={() => {}}
      title="Your cart"
      contents={() => (
        <OverviewPage
          onExit={closeDrawer}
          allProducts={allProducts?.all}
          goToFirstPage={() => {}}
        />
      )}
    />
  );
};

export default Cart;
